<template>
  <div class="card policy-chart-card csat-card h-100">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center justify-content-between gap-2">
        <h6 class="mb-0">Müştəri məmnuniyyəti indeksi</h6>
        <span class="badge bg-gradient-info csat-status-badge">{{ status.label }}</span>
      </div>
    </div>

    <div class="card-body policy-chart-body csat-body">
      <div class="csat-ring-wrap">
        <svg class="csat-svg" viewBox="0 0 200 124" aria-hidden="true">
          <defs>
            <linearGradient :id="uid + '-arc'" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#ef4444" />
              <stop offset="50%" stop-color="#f59e0b" />
              <stop offset="100%" stop-color="#22c55e" />
            </linearGradient>
          </defs>

          <path
            d="M 22 98 A 78 78 0 0 1 178 98"
            fill="none"
            stroke="var(--app-border, rgba(120, 130, 145, 0.2))"
            stroke-width="30"
            stroke-linecap="butt"
          />

          <path
            class="csat-arc"
            d="M 22 98 A 78 78 0 0 1 178 98"
            fill="none"
            :stroke="'url(#' + uid + '-arc)'"
            stroke-width="30"
            stroke-linecap="butt"
            :stroke-dasharray="arcLen"
            :stroke-dashoffset="arcOffset"
          />
        </svg>

        <div class="csat-center">
          <div class="csat-score">{{ score.toFixed(2) }}</div>
          <div class="csat-of">/ {{ maxScore.toFixed(2) }}</div>
          <div class="csat-stars" aria-label="Reytinq">
            <span
              v-for="n in 5"
              :key="n"
              class="csat-star"
              :class="{ 'is-filled': n <= fullStars, 'is-half': n === fullStars + 1 && hasHalf }"
            ></span>
          </div>
        </div>
      </div>

      <p class="csat-caption">{{ status.caption }}</p>
    </div>
  </div>
</template>

<script>
const R = 78;
const ARC_LEN = Math.PI * R;

export default {
  name: "GaugeChart",
  data() {
    return {
      uid: `csat-${Math.random().toString(36).slice(2, 8)}`,
      score: 4.43,
      maxScore: 5,
      arcLen: ARC_LEN,
    };
  },
  computed: {
    pct() {
      return Math.min(1, Math.max(0, this.score / this.maxScore));
    },
    arcOffset() {
      return this.arcLen * (1 - this.pct);
    },
    fullStars() {
      return Math.floor(this.score);
    },
    hasHalf() {
      return this.score - this.fullStars >= 0.25;
    },
    status() {
      if (this.score >= 4.5) {
        return { label: "Əla", tone: "great", caption: "Müştərilər xidmətdən çox məmnundur" };
      }
      if (this.score >= 4.0) {
        return { label: "Yaxşı", tone: "good", caption: "Ümumi məmnuniyyət səviyyəsi yüksəkdir" };
      }
      if (this.score >= 3.0) {
        return { label: "Orta", tone: "mid", caption: "Məmnuniyyət göstəricisi orta səviyyədədir" };
      }
      return { label: "Aşağı", tone: "low", caption: "Məmnuniyyət göstəricisi aşağıdır" };
    },
  },
};
</script>

<style scoped>
.csat-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.csat-status-badge {
  flex-shrink: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.csat-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.csat-ring-wrap {
  position: relative;
  width: 100%;
  max-width: 270px;
  height: 142px;
  margin: 0 auto;
}

.csat-svg {
  display: block;
  width: 100%;
  height: 142px;
}

.csat-arc {
  transition: stroke-dashoffset 1s cubic-bezier(0.22, 1, 0.36, 1);
}

.csat-center {
  position: absolute;
  left: 50%;
  top: 65%;
  transform: translate(-50%, -50%);
  line-height: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.csat-score {
  font-size: 2.35rem;
  font-weight: 800;
  color: var(--app-heading);
  letter-spacing: -0.04em;
}

.csat-of {
  margin-top: 0.1rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--app-text, #94a3b8);
}

.csat-stars {
  display: flex;
  justify-content: center;
  gap: 0.22rem;
  margin-top: 0.28rem;
}

.csat-star {
  width: 0.72rem;
  height: 0.72rem;
  background: var(--app-border, #e2e8f0);
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
}

.csat-star.is-filled {
  background: linear-gradient(180deg, #fbbf24 0%, #f59e0b 100%);
}

.csat-star.is-half {
  background: linear-gradient(90deg, #f59e0b 50%, var(--app-border, #e2e8f0) 50%);
}

.csat-caption {
  margin: 0.45rem 0 0;
  max-width: 220px;
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.45;
  color: var(--app-text, #64748b);
}
</style>
